import ProductTransformer from './ProductTransformer';

export default class ProductAdministrationSummaryTransformer extends ProductTransformer {
  static addFootnote(fn, product) {
    if (fn.name === 'footNoteAdministrationSummary') {
      product.footnotes.push(fn.text);
    }
  }

  static parseFootnotes(product, footnotes) {
    [
      'productName',
      'providerName',
      'descriptionAdministrationSummary',
      'linkInfoTextAdministrationSummary',
      'linkDescriptionAdministrationSummary',
      'textToBeConfirmedAdministrationSummary',
    ].forEach(field => {
      product.texts[field] = footnotes.parse(product.texts[field]);
    });
    if (product.textLists.textToBeConfirmedAdministrationSummary) {
      product.textLists.textToBeConfirmedAdministrationSummary.forEach((item, index) => {
        product.textLists.textToBeConfirmedAdministrationSummary[index] = footnotes.parse(product.textLists.textToBeConfirmedAdministrationSummary[index]);
      });
    }
  }
}
